import { C } from '../../lib/theme';
import { styles } from '../../lib/styles';
import { $ } from '../../lib/util';
import { Dialog } from '../Dialog';
import { useAppData } from '../../state/contexts/AppDataContext';
import { useUIState } from '../../state/contexts/UIStateContext';
import { useAdminActions } from '../../state/actions/admin';

export function LogLegalProcessModal() {
  const { cases } = useAppData();
  const { setModal } = useUIState();
  const { logLegalProcess } = useAdminActions();
  return (
    <Dialog title="Log Legal Process Receipt" onClose={() => setModal(null)}>
        <div style={{ marginBottom: 12 }}>
          <label htmlFor="lp-case" style={{ fontSize: 11, color: C.textMuted }}>Related Case</label>
          <select id="lp-case" style={{ ...styles.select, width: '100%' }}>
            {cases.map(c2 => <option key={c2.id} value={c2.id}>{c2.id} — {c2.registrant}</option>)}
          </select>
        </div>
        <div style={{ marginBottom: 16 }}>
          <label htmlFor="lp-desc" style={{ fontSize: 11, color: C.textMuted }}>Description</label>
          <textarea id="lp-desc" style={styles.textarea} placeholder="Describe the legal process, enforcement inquiry, or subpoena received..." />
        </div>
        <div style={{ fontSize: 11, color: C.warn, marginBottom: 16 }}>⚠ BCID LLC must be notified in writing within 24 hours of receipt (to the extent legally permitted)</div>
        <div style={{ display: 'flex', gap: 12 }}>
          <button style={{ ...styles.btn, ...styles.btnGold }} onClick={() => {
            const caseId = $('lp-case').value;
            const desc = $('lp-desc').value;
            if (desc) { logLegalProcess(caseId, desc); setModal(null); }
          }}>Log & Start 24hr Clock</button>
          <button style={{ ...styles.btn, ...styles.btnOutline }} onClick={() => setModal(null)}>Cancel</button>
        </div>
    </Dialog>
  );
}
